export default (url) => {
  if (url.indexOf('upload-hz-vo') > -1 && url.indexOf('x-oss-process') == -1) {
    return url + '?x-oss-process=image/resize,h_60'
  }
  return url
}



// WEBPACK FOOTER //
// src/helper/avatar.js